import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferenceRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 3,
			width: 14,
			height: 14,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 8v11a2 2 0 0 0 2 2h11" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 7.5,
			r: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M10.5 17v-1.5a3.5 3.5 0 0 1 7 0V17" })
	]
});
export default SvgReferenceRoute;
